import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=b86fc1de&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"
import style0 from "./Notification.vue?vue&type=style&index=0&id=b86fc1de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86fc1de",
  null
  
)

export default component.exports